import { NECK_LINE_STEP } from "../misc/constants";

export const getDisplayedSize = size => parseFloat(size).toFixed(2);

export const getSizeWithSteps = height => {
  const heightInInches = getDisplayedSize(height);
  const distance = getDisplayedSize(heightInInches % NECK_LINE_STEP);
  return getDisplayedSize(heightInInches - distance);
};

export default {};
